import React, { useState } from "react";
import { Box, Typography, Button } from "@mui/material";
import { useStyles } from "../SLAManagement.styles";
import { SLA_CONFIG } from "../SLAManagement.config";
import { ActionTaskType, ActionType, SLAStatus } from "src/Modules/Company/Enums";
import { useModal, useStore } from "src/Shared/Hooks";
import { observer } from "mobx-react";
import AddOrEditAction from "src/Modules/Company/Components/AddOrEditAction/AddOrEditAction";
import { VIEW_MODE } from "src/Shared/Enums/ViewMode.enum";
import { ICompanyOverview } from "src/Modules/Company/Interfaces/ICompanyOverview";
import { ISalesDealFilter } from "src/Modules/Company/Interfaces/ISalesDealFilter";
import { IPageRequest } from "src/Shared/Interfaces";
import { ISalesAction } from "src/Modules/Company/Interfaces";
import { useEffect } from "react";
import { PicUp_Component } from "src/Shared/Enums";
import { CustomDataGrid } from "src/Shared/Components";
import { GridPaginationModel } from "@mui/x-data-grid";
import { assignedColumns } from "./ReviewAction.column";

export interface ReviewAction {
  id: number;
  title: string;
  channel: string;
  assignedTo: string;
  dueDate: string;
  status: string;
}

type ReviewActionStatus = "In Progress" | "Completed";

interface ReviewActionsTabProps {
  currentStatus: SLAStatus;
  companyOverview?: ICompanyOverview;
}

const ReviewActionsTab: React.FC<ReviewActionsTabProps> = ({
  currentStatus,
  companyOverview,
}) => {

  const {
    rootStore: {
      salesActionStore: {
        gridLoading,
        salesActionList,
        getSalesActionGridList,
        refreshSalesActionGridList,
      },
    },
  } = useStore();

  const classes = useStyles();
  const modal = useModal();

  const renderStatusPill = (status: string) => {
    const statusClassName =
      status === "Completed"
        ? classes.statusPillSuccess
        : classes.statusPillWarning;

    return (
      <Box className={`${classes.statusPill} ${statusClassName}`}>{status}</Box>
    );
  };

  const addReviewAction = () => {
    modal.open(
      <AddOrEditAction
        mode={VIEW_MODE.ADD}
        actionType={ActionType.CRMAction}
        actionTaskTypeID={ActionTaskType.CRMAction_SLAReview}
        heading="Add SLA Review Action"
        primaryRelationshipManager={companyOverview.primaryCompanyRelationshipManager}
        companyRowID={companyOverview.companyRowID}
        picupComponent={PicUp_Component.SLAReviewAction}
      />
    );

  };

  const [request, setRequest] = useState<
    IPageRequest<ISalesDealFilter> | null
  >(null);

  useEffect(() => {
    if (!companyOverview?.companyRowID) return;
    setRequest({
      pageNumber: 1,
      pageSize: 10,
      filterCollection: {
        companyRowID: companyOverview.companyRowID,
        actionTypeID: ActionType.CRMAction,
        actionTaskTypeID: ActionTaskType.CRMAction_SLAReview,
      },
      sortCollection: [],
    });
  }, [companyOverview]);

  useEffect(() => {
    if (!request) return;
    getSalesActionGridList(request);
  }, [request]);

  const onGridPaginationChange = (data: GridPaginationModel) => {
    setGridPagination(data);
    setRequest({
      filterCollection: {
        companyRowID: companyOverview.companyRowID,
        actionTypeID: ActionType.CRMAction,
        actionTaskTypeID: ActionTaskType.CRMAction_SLAReview,
      },
      sortCollection: [],
      pageNumber: data.page + 1,
      pageSize: data.pageSize,
    });
  };

   const [gridPagination, setGridPagination] = useState<GridPaginationModel>({
    page: 0,
    pageSize: 10,
  });


  const currentStatusConfig = SLA_CONFIG[currentStatus];

  const canManageReviewActions =
    currentStatusConfig.price !== "readonly" &&
    (currentStatusConfig.price !== "hidden" || currentStatusConfig.reminder);

  return (
    <Box className={classes.tabPanel}>
      <Box className={classes.actionsHeader}>
        <Typography variant="body2" className={classes.helperTextMuted}>
          {canManageReviewActions
            ? "Track follow-ups, renewal work, and price review tasks here."
            : "SLA review actions are locked until this status requires them."}
        </Typography>

        <Button
          variant="outlined"
          onClick={addReviewAction}
        >
          + Add SLA review action
        </Button>
      </Box>

      <CustomDataGrid
        loading={gridLoading}
        columns={assignedColumns()}
        rowSelection={false}
        rows={salesActionList.results || []}
        rowCount={salesActionList.totalNumberOfRecords || 0}
        rowHeight={70}
        style={{ height: "calc(100vh - 255px)" }}
        paginationModel={gridPagination}
        getRowId={(row: ISalesAction) => row.companyActionID}
        onPaginationModelChange={(model) => onGridPaginationChange(model)}
      />
    </Box>
  );
};

export default observer(ReviewActionsTab);
function setGridPagination(data: GridPaginationModel) {
  throw new Error("Function not implemented.");
}

